// Store
import * as BulkVoidActions from '../../../store/bulk/void/bulk.void.actions';

export const RequestVoidStep = (state, jobId) => [BulkVoidActions.requestVoid(jobId)];
